import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import permission from './modules/permission'
import tagsView from './modules/tagsView'
import user from './modules/user'
import getters from './getters'
import systemInfo from './modules/systemInfo'
import lang from './modules/langJson'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    permission,
    tagsView,
    systemInfo,
    user,
    lang,
  },
  getters
})

export default store
